import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalEquipmentListComponent } from './internal-equipment-list.component';
import { InternalEquipmentListFilterComponent } from './internal-equipment-list-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/external-components/angular-material.module';
import { SharedModule } from '../../shared/shared.module';
import { FlexLayoutModule } from 'ng-flex-layout';
import { PipesModule } from 'src/app/pipes/pipes.module';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [InternalEquipmentListComponent, InternalEquipmentListFilterComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    /* Custom modules */
    AngularMaterialModule,
    SharedModule,
    PipesModule,

    /* Otros */
    FlexLayoutModule,
    RouterModule
  ],
  exports: [InternalEquipmentListComponent, InternalEquipmentListFilterComponent]
})
export class InternalEquipmentListModule { }
